
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/settings",
      function () {
        return require("private-next-pages/agents/settings.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/settings"])
      });
    }
  